import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { getTaxConfiguration } from './taxDisplayModes';
import usePricingContext from '../../../hooks/usePricingContext';

const TaxDisplayContext = React.createContext();

/**
 * Responsible for determining whether tax inclusive or tax exclusive pricing should be shown.
 */
const TaxDisplayProvider = ({ children, taxDisplayMode }) => {
  const [currentTaxDisplayMode, setTaxDisplayMode] = useState(taxDisplayMode);

  /*
   * This is - for now - the best place initialize the pricing context library
   * even though the pricing context does not have any affect on displaying
   * prices as tax inclusive or exclusive. In ODUI, we always show prices as tax
   * inclusive, even if the taxes were 0, because that is what the customer paid.
   * And its consistent with other UIs.
   */
  usePricingContext();

  const taxDisplayContextValues = useMemo(
    () => ({
      taxDisplayMode: currentTaxDisplayMode,
      setTaxDisplayMode,
      taxDisplayConfiguration: getTaxConfiguration(currentTaxDisplayMode),
    }),
    [currentTaxDisplayMode]
  );

  return (
    <TaxDisplayContext.Provider value={taxDisplayContextValues}>
      {children}
    </TaxDisplayContext.Provider>
  );
};

TaxDisplayProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  taxDisplayMode: PropTypes.string.isRequired,
};

export { TaxDisplayContext, TaxDisplayProvider };
